export const getDevices = async (type: MediaDeviceKind = 'audioinput') => {
  const devices = await navigator.mediaDevices.enumerateDevices()
  return devices.filter(d => d.kind === type)
}
